import React from "react";
import BaseButtonOutlined from "../../sisu/button/BaseButtonOutlined.sisu";

const NeoButtonOutlined = (props) => {
    return (
        <BaseButtonOutlined custom="p-button-rounded p-button-outlined" {...props} />
    );
};

export default NeoButtonOutlined;